var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 208,
    viewBox: "0 0 1280 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.508 9.17034C156.004 3.05678 138.286 0 118.353 0C94.0825 0 73.0881 4.26097 55.3698 12.7829C37.6515 21.3048 23.9936 33.3467 14.3961 48.9085C4.79871 64.3776 0 82.672 0 103.792V103.931C0 125.05 4.79871 143.391 14.3961 158.953C23.9936 174.514 37.6515 186.603 55.3698 195.217C73.0881 203.739 94.0825 208 118.353 208C138.194 208 155.912 204.943 171.508 198.83C187.104 192.716 199.885 184.055 209.852 172.847C219.794 161.666 226.201 148.503 229.072 133.358C229.079 133.322 229.086 133.285 229.092 133.248L229.369 131.858H199.747L199.331 132.831C195.917 143.391 190.518 152.33 183.136 159.647C175.845 166.965 166.755 172.569 155.866 176.46C145.069 180.257 132.611 182.156 118.491 182.156C100.312 182.156 84.6235 178.914 71.427 172.43C58.2306 165.946 48.0333 156.868 40.8352 145.197C33.6371 133.433 30.0381 119.678 30.0381 103.931V103.792C30.0381 88.0445 33.591 74.3353 40.6968 62.664C47.8949 50.9927 58.0921 41.9613 71.2886 35.5698C84.4851 29.0857 100.219 25.8437 118.491 25.8437C132.795 25.8437 145.392 27.6963 156.281 31.4015C167.171 35.1067 176.214 40.5255 183.412 47.658C190.611 54.7905 195.871 63.4513 199.193 73.6406L199.747 75.4469H229.369L229.092 73.9185C226.232 58.8199 219.818 45.7591 209.852 34.7361C199.885 23.7132 187.104 15.1913 171.508 9.17034ZM227.571 73.9469C224.736 59.2159 218.459 46.4924 208.739 35.7421C198.948 24.914 186.372 16.5168 170.968 10.5697L170.958 10.5658C155.66 4.53341 138.134 1.5 118.353 1.5C94.256 1.5 73.4935 5.73045 56.0199 14.1347C38.5398 22.542 25.1083 34.3968 15.6729 49.6959L15.6708 49.6993C6.24295 64.895 1.5 82.9059 1.5 103.792V103.931C1.5 124.816 6.24288 142.875 15.6729 158.165C25.1089 173.465 38.5417 185.367 56.0238 193.867C73.4966 202.27 94.2578 206.5 118.353 206.5C138.04 206.5 155.568 203.467 170.96 197.433C186.362 191.396 198.939 182.862 208.731 171.85C218.426 160.947 224.697 148.127 227.544 133.358H200.737C197.253 144.1 191.742 153.227 184.195 160.709C176.73 168.201 167.443 173.916 156.371 177.872L156.364 177.875C145.374 181.74 132.742 183.656 118.491 183.656C100.135 183.656 84.2107 180.383 70.7655 173.776C57.3346 167.177 46.9157 157.914 39.5585 145.984L39.5557 145.98C32.1939 133.948 28.5381 119.914 28.5381 103.931V103.792C28.5381 87.8121 32.146 73.8243 39.4156 61.884L39.4201 61.8766C46.7777 49.9465 57.1978 40.7286 70.6306 34.2218C84.076 27.6162 100.046 24.3437 118.491 24.3437C132.921 24.3437 145.687 26.2122 156.764 29.9814C167.84 33.7499 177.088 39.2795 184.468 46.5925C191.845 53.9025 197.227 62.773 200.619 73.1756L200.623 73.1883L200.856 73.9469H227.571Z",
    fill: "url(#paint0_linear_5416_8243)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.826 3.7515H431.956V29.0394H345.995V204.248H316.649V29.0394H230.826V3.7515ZM318.149 27.5394V202.748H344.495V27.5394H430.456V5.2515H232.326V27.5394H318.149Z",
    fill: "url(#paint1_linear_5416_8243)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.007 29.0394H818.969V3.7515H617.838V29.0394H703.661V204.248H733.007V29.0394ZM731.507 202.748V27.5394H817.469V5.2515H619.338V27.5394H705.161V202.748H731.507Z",
    fill: "url(#paint2_linear_5416_8243)",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1222.14 9.17034C1206.64 3.05678 1188.92 0 1168.98 0C1144.71 0 1123.72 4.26097 1106 12.7829C1088.28 21.3048 1074.62 33.3467 1065.03 48.9085C1055.43 64.3776 1050.63 82.672 1050.63 103.792V103.931C1050.63 125.05 1055.43 143.391 1065.03 158.953C1074.62 174.514 1088.28 186.603 1106 195.217C1123.72 203.739 1144.71 208 1168.98 208C1188.82 208 1206.54 204.943 1222.14 198.83C1237.73 192.716 1250.52 184.055 1260.48 172.847C1270.42 161.666 1276.83 148.503 1279.7 133.358C1279.71 133.322 1279.72 133.285 1279.72 133.248L1280 131.858H1250.38L1249.96 132.831C1246.55 143.391 1241.15 152.33 1233.77 159.647C1226.48 166.965 1217.39 172.569 1206.5 176.46C1195.7 180.257 1183.24 182.156 1169.12 182.156C1150.94 182.156 1135.25 178.914 1122.06 172.43C1108.86 165.946 1098.66 156.868 1091.47 145.197C1084.27 133.433 1080.67 119.678 1080.67 103.931V103.792C1080.67 88.0445 1084.22 74.3353 1091.33 62.664C1098.53 50.9927 1108.72 41.9613 1121.92 35.5698C1135.12 29.0857 1150.85 25.8437 1169.12 25.8437C1183.43 25.8437 1196.02 27.6963 1206.91 31.4015C1217.8 35.1067 1226.84 40.5255 1234.04 47.658C1241.24 54.7905 1246.5 63.4513 1249.82 73.6406L1250.38 75.4469H1280L1279.72 73.9185C1276.86 58.8199 1270.45 45.7591 1260.48 34.7361C1250.52 23.7132 1237.73 15.1913 1222.14 9.17034ZM1278.2 73.9469C1275.37 59.2158 1269.09 46.4924 1259.37 35.7421C1249.58 24.914 1237 16.5168 1221.6 10.5697L1221.59 10.5658C1206.29 4.53341 1188.76 1.5 1168.98 1.5C1144.89 1.5 1124.12 5.73045 1106.65 14.1347C1089.17 22.542 1075.74 34.3968 1066.3 49.6959L1066.3 49.6993C1056.87 64.895 1052.13 82.9059 1052.13 103.792V103.931C1052.13 124.816 1056.87 142.875 1066.3 158.165C1075.74 173.466 1089.17 185.368 1106.66 193.868C1124.13 202.271 1144.89 206.5 1168.98 206.5C1188.67 206.5 1206.2 203.467 1221.59 197.433C1236.99 191.396 1249.57 182.862 1259.36 171.85C1269.06 160.947 1275.33 148.127 1278.18 133.358L1251.37 133.358C1247.88 144.101 1242.37 153.23 1234.82 160.713C1227.36 168.203 1218.07 173.917 1207 177.872L1206.99 177.875C1196.01 181.74 1183.37 183.656 1169.12 183.656C1150.77 183.656 1134.84 180.383 1121.4 173.776C1107.97 167.177 1097.55 157.914 1090.19 145.984L1090.19 145.98C1082.82 133.948 1079.17 119.914 1079.17 103.931V103.792C1079.17 87.8121 1082.78 73.8243 1090.05 61.884L1090.05 61.8766C1097.41 49.9475 1107.83 40.7302 1121.26 34.2235C1134.7 27.6168 1150.67 24.3437 1169.12 24.3437C1183.55 24.3437 1196.32 26.2122 1207.4 29.9814C1218.47 33.7499 1227.72 39.2795 1235.1 46.5925C1242.48 53.9025 1247.86 62.773 1251.25 73.1756L1251.25 73.1883L1251.49 73.9469H1278.2Z",
    fill: "url(#paint3_linear_5416_8243)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M839.96 4.16834H876.585L949.673 104.487L1022.92 4.16834H1059.22L911.257 204.248H874.306L931.93 128.486L839.96 4.16834ZM933.805 128.498L877.332 202.748H910.501L1056.25 5.66834H1023.69L949.672 107.033L875.822 5.66834H842.935L933.805 128.498Z",
    fill: "url(#paint4_linear_5416_8243)",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527.674 51.2167L608.346 179.071H447.003L527.674 51.2167ZM527.674 54.0277L605.625 177.571H449.723L527.674 54.0277Z",
    fill: "url(#paint5_linear_5416_8243)",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.431 204.248H653.917L527.674 4.16834L401.431 204.248ZM404.151 202.748L527.674 6.97937L651.197 202.748H404.151Z",
    fill: "url(#paint6_linear_5416_8243)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5416_8243",
    x1: 663.5,
    y1: 0,
    x2: 663.5,
    y2: 221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5416_8243",
    x1: 663.5,
    y1: 0,
    x2: 663.5,
    y2: 221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5416_8243",
    x1: 663.5,
    y1: 0,
    x2: 663.5,
    y2: 221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5416_8243",
    x1: 663.5,
    y1: 0,
    x2: 663.5,
    y2: 221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5416_8243",
    x1: 663.5,
    y1: 0,
    x2: 663.5,
    y2: 221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5416_8243",
    x1: 663.5,
    y1: 0,
    x2: 663.5,
    y2: 221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5416_8243",
    x1: 663.5,
    y1: 0,
    x2: 663.5,
    y2: 221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStatus);
export default __webpack_public_path__ + "static/media/LogoStatus.a4a58f87e985ecdcd81b6eb7cb8ec2c3.svg";
export { ForwardRef as ReactComponent };